import {
  DEFAULT_SCAN_FAMILIES,
  SCAN_FAMILY_OPTIONS,
  type StaticScanFamily,
  toggleScanFamily,
} from "./scanFamilyScope.js";
import "./scan-family-picker.css";

export function ScanFamilyPicker({
  selected = DEFAULT_SCAN_FAMILIES,
  onChange,
}: {
  selected?: readonly StaticScanFamily[];
  onChange: (next: readonly StaticScanFamily[]) => void;
}) {
  return (
    <fieldset className="scan-family-picker">
      <legend>What to scan for</legend>
      <p>Everything supported is selected by default. Uncheck a family to skip it on this run.</p>
      <ul>
        {SCAN_FAMILY_OPTIONS.map((option) => {
          const checked = option.selectable && selected.includes(option.id as StaticScanFamily);
          return (
            <li key={option.id}>
              <label className={option.selectable ? undefined : "scan-family-picker__disabled"}>
                <input
                  type="checkbox"
                  checked={checked}
                  disabled={!option.selectable}
                  onChange={() => {
                    if (!option.selectable) return;
                    onChange(toggleScanFamily(selected, option.id as StaticScanFamily));
                  }}
                />
                <span>
                  <strong>{option.label}</strong>
                  <small>{option.selectable ? option.detail : "Unavailable"}</small>
                </span>
              </label>
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
}
